// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__EW5QQ","label":"styles_label__s99hr","icon":"styles_icon__T04tq"};